import React, { useState } from "react";
import { Button } from "primereact/button";
import { Accordion, AccordionTab } from "primereact/accordion";
import MenuReduzido from "./MenuReduzido";
import MenuSuperior from "./MenuSuperior";

export default function FlexToggle() {
    const [expanded, setExpanded] = useState(false);

    const toggleSidebar = () => {
        const sidebar = document.querySelector('.sidebar');
        sidebar.classList.toggle('expanded');
    }
    return (
        <div className="container ">
        <div className="sidebar p-menu noRadius" style={{padding : '10px'}}>
            <button  onClick={()=>toggleSidebar()}>Teste</button>
                <MenuReduzido />
        </div>
        <div className="content">
            <MenuSuperior />
            <div style={{
                width : '100%'
            }}></div>
        </div>
    </div>
    );
}
